import { combineReducers } from 'redux';
import { reducer as throttleDispatch } from './throttleDispatch';

export default combineReducers({ throttleDispatch });
